import React from 'react';

import MobileNotifications from 'components/organisms/Profile/Notifications/MobileNotifications';
import TabletNotifications from 'components/organisms/Profile/Notifications/TabletNotifications';
import DesktopNotifications from 'components/organisms/Profile/Notifications/DesktopNotifications';
import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';

const Notifications = ({ setSelected }) => {
    const { auth, currentUser, updateNotificationPreferences } = useAuth();
    const { device } = useViewport();

    const preferences = auth.notification;

    const preferenceListItems = {
        student: [
            {
                key: 'task_updates',
                value: preferences?.task_updates?.email !== false,
                title: 'Task Updates',
                description:
                    'Be notified when you are assigned a task and when any change or comment is made to your tasks.',
            },
            {
                key: 'direct_messages',
                value: preferences?.direct_messages?.email !== false,
                title: 'Direct Messages',
                description: 'Be notified when you have unread direct messages from a teammate or instructor.',
            },
            {
                key: 'channel_messages',
                value: preferences?.channel_messages?.email !== false,
                title: 'Channel Messages',
                description:
                    'Be notified when you are added to a new channel and receive updates on unread channel messages.',
            },
        ],
        instructor: [
            {
                key: 'direct_messages',
                value: preferences?.direct_messages?.email !== false,
                title: 'Direct Messages',
                description: 'Be notified when you have unread direct messages from another user.',
            },
            {
                key: 'channel_messages',
                value: preferences?.channel_messages?.email !== false,
                title: 'Channel Messages',
                description:
                    'Be notified when you are added to a new channel and receive updates on unread channel messages.',
            },
        ],
    };

    const handleChangeWeeklySummaries = (value) => {
        updateNotificationPreferences({
            ...preferences,
            weekly_summaries: {
                ...preferences?.weekly_summaries,
                email: value,
            },
            project_overview: {
                ...preferences?.project_overview,
                email: value,
            },
            review_suggestions: {
                ...preferences?.review_suggestions,
                email: value,
            },
            unread_messages: {
                ...preferences?.unread_messages,
                email: value,
            },
            status_updates_ontrack: {
                ...preferences?.status_updates_ontrack,
                email: value,
            },
            status_updates_caution: {
                ...preferences?.status_updates_caution,
                email: value,
            },
            status_updates_offtrack: {
                ...preferences?.status_updates_offtrack,
                email: value,
            },
        });
    };

    const handleChange = (key, value) => {
        if (key === 'weekly_summaries') return handleChangeWeeklySummaries(value);

        let newPreferences;
        if (['weekday', 'time'].includes(key)) {
            newPreferences = {
                ...preferences,
                weekly_summaries: {
                    ...preferences?.weekly_summaries,
                    [key]: value,
                },
            };
        } else {
            newPreferences = {
                ...preferences,
                [key]: {
                    ...preferences?.[key],
                    email: value,
                },
            };
        }

        if (key === 'status_updates') {
            newPreferences = {
                ...newPreferences,
                status_updates_ontrack: { email: value },
                status_updates_caution: { email: value },
                status_updates_offtrack: { email: value },
            };
        }

        if (
            [
                'project_overview',
                'review_suggestions',
                'unread_messages',
                'status_updates',
                'status_updates_ontrack',
                'status_updates_caution',
                'status_updates_offtrack',
            ].includes(key)
        ) {
            newPreferences = {
                ...newPreferences,
                weekly_summaries: {
                    ...newPreferences?.weekly_summaries,
                    email: !(
                        newPreferences?.project_overview?.email === false &&
                        newPreferences?.review_suggestions?.email === false &&
                        newPreferences?.unread_messages?.email === false &&
                        newPreferences?.status_updates_ontrack?.email === false &&
                        newPreferences?.status_updates_caution?.email === false &&
                        newPreferences?.status_updates_offtrack?.email === false
                    ),
                },
            };
        }

        updateNotificationPreferences(newPreferences);
    };

    const props = {
        timeZone: currentUser.timezone,
        preferences,
        preferenceListItems: preferenceListItems[auth.role],
        role: auth.role,
        onChange: handleChange,
    };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <MobileNotifications {...props} setSelected={setSelected} />,
            tablet: <TabletNotifications {...props} />,
            desktop: <DesktopNotifications {...props} />,
        }[device];
    };

    return <>{renderResponsiveLayout(device)}</>;
};

export default Notifications;
